import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  production: boolean;
  URL: string;
  invitationUrl: string;
}

// Context token to skip interceptors
export const SKIP_INTERCEPTOR = 'SKIP_INTERCEPTOR';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig | null = null;

  constructor(private http: HttpClient) { }

  /**
   * Load configuration from assets/config.json
   * This file will have tokens replaced by Azure App Settings at runtime
   */
  async loadConfig(): Promise<void> {
    try {
      // Use a request that bypasses interceptors to avoid circular dependency
      const req = this.http.get<AppConfig>('assets/config.json', {
        headers: { [SKIP_INTERCEPTOR]: 'true' }
      });
      
      this.config = await firstValueFrom(req);
      console.log('Configuration loaded successfully');
    } catch (error) {
      console.error('Error loading configuration:', error);
      
    }
  }

  /**
   * Get the entire configuration object
   */
  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Configuration not loaded. Call loadConfig() first.');
    }
    return this.config;
  }

  /**
   * Get API URL
   */
  getApiUrl(): string {
    return this.getConfig().URL;
  }

  /**
   * Get Invitation URL
   */
  getInvitationUrl(): string {
    return this.getConfig().invitationUrl;
  }

  /**
   * Check if running in production mode
   */
  isProduction(): boolean {
    return this.getConfig().production;
  }
}
